"use client"
import React, { forwardRef, ComponentPropsWithoutRef } from "react";
import { Button } from "../button";
import { cn } from "@/lib/utils";

interface IProps {
  href?: string;
}

const GradientButton = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<typeof Button> & IProps
>(({ children, className, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      className={cn(
        "group relative cursor-pointer overflow-hidden bg-radial-[at_bottom_right] from-[#100588] to-[#5231E7] to-60% rounded-full shadow-[0px_4px_11.600000381469727px_0px_rgba(82,49,231,0.30)] border-2 outline-white inline-flex justify-center items-center gap-1 md:gap-2 md:px-6.5 md:py-6.5 py-6 px-6 text-md md:text-base font-medium md:font-semibold lg:text-base hover:scale-[1.02] transition-transform duration-300",
        className
      )}
      {...props}
    >
      {/* Shimmer effect */}
      <span
        className="absolute inset-0 w-full h-full"
        style={{
          background:
            "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
          transform: "translateX(-100%)",
          animation: "shimmer 2.5s infinite",
        }}
      />

      <style jsx global>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          60% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
      <p className="relative z-10 leading-[1.1]">{children}</p>
    </Button>
  );
});

export default GradientButton;
